import { useElementAuth } from '../../store'

export function ElementSettingsPage() {
  const {
    authenticatedMailbox,
    performElementLogout
  } = useElementAuth()

  const usedStoragePercentage = authenticatedMailbox
    ? Math.round((authenticatedMailbox.quota.usedBytes / authenticatedMailbox.quota.totalBytes) * 100)
    : 0

  const usedStorageMegabytes = authenticatedMailbox
    ? (authenticatedMailbox.quota.usedBytes / 1024 / 1024).toFixed(1)
    : '0'

  const totalStorageGigabytes = authenticatedMailbox
    ? (authenticatedMailbox.quota.totalBytes / 1024 / 1024 / 1024).toFixed(0)
    : '0'

  async function handleLogoutButtonClick(): Promise<void> {
    await performElementLogout()
  }

  return (
    <div className="element-settings-page">
      <div className="element-settings-header">
        <h2 className="element-settings-title">Settings</h2>
      </div>

      <div className="element-settings-section">
        <h3 className="element-settings-section-title">Account</h3>
        <div className="element-settings-account-info">
          <div className="element-settings-info-row">
            <span className="element-settings-info-label">Email address</span>
            <span className="element-settings-info-value">
              {authenticatedMailbox?.email || '—'}
            </span>
          </div>
          <div className="element-settings-info-row">
            <span className="element-settings-info-label">Display name</span>
            <span className="element-settings-info-value">
              {authenticatedMailbox?.displayName || '—'}
            </span>
          </div>
        </div>
      </div>

      <div className="element-settings-section">
        <h3 className="element-settings-section-title">Storage</h3>
        <div className="element-settings-storage-info">
          <div className="element-storage-usage-bar-container">
            <div
              className="element-storage-usage-bar-fill"
              style={{ width: `${usedStoragePercentage}%` }}
              role="progressbar"
              aria-valuenow={usedStoragePercentage}
              aria-valuemin={0}
              aria-valuemax={100}
            />
          </div>
          <p className="element-storage-usage-label">
            {usedStorageMegabytes} MB used of {totalStorageGigabytes} GB
          </p>
        </div>
      </div>

      <div className="element-settings-section">
        <h3 className="element-settings-section-title">Session</h3>
        <button
          className="element-settings-logout-button"
          onClick={handleLogoutButtonClick}
        >
          Sign out
        </button>
      </div>
    </div>
  )
}
